import countries from 'country-flags-svg/dist/data/countries';
import PropTypes from 'prop-types';

import Field from 'Component/Field';
import FIELD_TYPE from 'Component/Field/Field.config';
import Image from 'Component/Image';
import Loader from 'Component/Loader';
import {
    StoreSwitcher as SourceStoreSwitcher
} from 'SourceComponent/StoreSwitcher/StoreSwitcher.component';

import './StoreSwitcher.override.style';

/** @namespace PeggysagePwa/Component/StoreSwitcher/Component */
export class StoreSwitcherComponent extends SourceStoreSwitcher {
    static propTypes = {
        ...SourceStoreSwitcher.propTypes,
        storeListByWebsite: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string,
                label: PropTypes.string,
                value: PropTypes.string,
                stores: PropTypes.arrayOf(
                    PropTypes.objectOf(
                        PropTypes.string
                    )
                ),
                is_hidden: PropTypes.bool
            })
        ).isRequired,
        currentWebsiteCode: PropTypes.string.isRequired,
        isLoading: PropTypes.bool.isRequired,
        handleWebsiteSelect: PropTypes.func.isRequired
    };

    /**
     * Transform single select into 2 (website and store)
     * @returns {JSX.Element}
     */
    renderMobileStoreSwitcher() {
        const {
            // storeList,
            storeListByWebsite,
            handleStoreSelect,
            currentStoreCode,
            currentWebsiteCode,
            isLoading,
            handleWebsiteSelect
        } = this.props;

        // eslint-disable-next-line
        let storeList = [];
        // eslint-disable-next-line
        let flagUrl = '';

        if (currentWebsiteCode && storeListByWebsite) {
            const currentWebsite = storeListByWebsite.filter((website) => website.value === currentWebsiteCode)[0];
            if (currentWebsite && currentWebsite.stores) {
                storeList = currentWebsite.stores;

                const countryIso3 = countries.find(
                    (country) => country.iso2.toUpperCase() === currentWebsite.value.toUpperCase()
                )?.iso3 || null;

                if (countryIso3) {
                    flagUrl = `${process.env.PUBLIC_URL}/images/flags/${countryIso3}.svg`;
                }
            }
        }

        const websiteSwitcherOptions = storeListByWebsite.map((website) => (
            { label: website.label, value: website.value, hidden: website.is_hidden }
        ));

        const websiteSwitcherOptionsFinal = websiteSwitcherOptions.filter((website) => ((website.value === currentWebsiteCode) || !website.hidden));

        return (
            <div block="StoreSwitcher">
                <Loader isLoading={ isLoading } />
                <Image
                  mix={ { block: 'StoreSwitcher', elem: 'CurrentWebsiteFlag' } }
                  src={ flagUrl }
                  isPlaceholder={ !flagUrl }
                  alt=""
                  ratio="custom"
                />
                <Field
                  type={ FIELD_TYPE.select }
                  attr={ {
                      id: 'WebsiteSwitcher',
                      name: 'WebsiteSwitcher',
                      defaultValue: currentWebsiteCode,
                      noPlaceholder: true
                  } }
                  events={ {
                      onChange: handleWebsiteSelect
                  } }
                  options={ websiteSwitcherOptionsFinal }
                />
                <Field
                  type={ FIELD_TYPE.select }
                  attr={ {
                      id: 'StoreSwitcher',
                      name: 'StoreSwitcher',
                      defaultValue: currentStoreCode,
                      noPlaceholder: true
                  } }
                  events={ {
                      onChange: handleStoreSelect
                  } }
                  options={ storeList }
                />
            </div>
        );
    }

    /**
     * Same rendering on desktop and mobile
     * @returns {null|*}
     */
    render() {
        const { storeList } = this.props;

        if (storeList.length < 1) {
            return null;
        }

        return this.renderMobileStoreSwitcher();
    }
}

export default StoreSwitcherComponent;
